export default {
  'home.metaTitle': 'USFans Spreadsheet 2026 — Trouvez des produits, QC et guide d\u2019achat',
  'hero.h1': 'USFans Spreadsheet — Trouvez des produits, vérifiez le QC et achetez mieux',
  'hero.subtitle': 'Explorez USFans Spreadsheet avec des guides pratiques, des catégories de produits, des conseils QC, des informations de livraison, des conseils de sécurité et les dernières ressources d\u2019achat — le tout organisé au même endroit.',
  'hero.usfansSpreadsheet': 'USFans Spreadsheet',
  'hero.buyNow': 'Acheter maintenant',
  'hero.startGuide': 'Commencer par le guide débutant',
  'hero.trust': 'Ressource indépendante • Mise à jour régulière • Multilingue',
  'hero.microcopy': 'Vous cherchez des liens USFans Spreadsheet ? Commencez ici. Parcourez les catégories, comprenez le QC, comparez les options et découvrez quoi vérifier avant de commander.',
  'hero.dropdownLabel': 'Choisissez une catégorie à ouvrir',

  'categories.title': 'Catégories USFans Spreadsheet',
  'categories.subtitle': 'Parcourez les produits par catégorie et accédez directement à ce que vous cherchez.',
  'categories.open': 'Ouvrir',

  'what.title': 'Qu\u2019est-ce que le USFans Spreadsheet ?',
  'what.body': 'Le USFans Spreadsheet est un moyen pratique de découvrir et d\u2019organiser des liens de produits, des catégories et des informations d\u2019achat. Au lieu de chercher dans des publications et des liens éparpillés, notre centre de ressources rassemble les informations les plus utiles dans une expérience structurée et consultable.',
  'what.cta': 'Explorer le guide du Spreadsheet',

  'guides.title': 'Tout ce que vous devez savoir sur USFans',
  'guides.subtitle': 'Des guides pratiques sur les sujets que les acheteurs posent le plus souvent.',
  'guides.spread.title': 'USFans Spreadsheet',
  'guides.spread.desc': 'Trouvez et comprenez les ressources du spreadsheet.',
  'guides.review.title': 'Avis USFans',
  'guides.review.desc': 'Découvrez ce que les acheteurs devraient considérer avant d\u2019utiliser la plateforme.',
  'guides.shipping.title': 'Coût de livraison USFans',
  'guides.shipping.desc': 'Comprenez les facteurs qui influencent les coûts de livraison internationale.',
  'guides.coupon.title': 'Coupon USFans',
  'guides.coupon.desc': 'Découvrez comment fonctionnent les coupons, promotions et codes de réduction.',
  'guides.warehouse.title': 'Entrepôt USFans',
  'guides.warehouse.desc': 'Comprenez le stockage, l\u2019inspection et la préparation des colis.',
  'guides.legit.title': 'USFans est-il légitime ?',
  'guides.legit.desc': 'Lisez notre guide pratique sur la sécurité et la légitimité.',

  'why.title': 'Pourquoi utiliser notre ressource USFans Spreadsheet ?',
  'why.item1': 'Des guides faciles à suivre',
  'why.item2': 'Une navigation claire par catégories',
  'why.item3': 'Une éducation au QC',
  'why.item4': 'Des explications sur la livraison',
  'why.item5': 'Des informations de sécurité',
  'why.item6': 'Des tableaux comparatifs',
  'why.item7': 'Des tutoriels pour débutants',
  'why.item8': 'Des mises à jour régulières du contenu',

  'startHere.title': 'Commencez ici',
  'startHere.subtitle': 'Nouveau sur USFans ? Suivez notre parcours débutant :',
  'startHere.step1': 'Comprenez le USFans Spreadsheet',
  'startHere.step2': 'Trouvez des produits',
  'startHere.step3': 'Vérifiez les informations produit',
  'startHere.step4': 'Comprenez le QC',
  'startHere.step5': 'Renseignez-vous sur la livraison',
  'startHere.step6': 'Examinez les aspects de sécurité',
  'startHere.step7': 'Continuez vers le site principal',
  'startHere.cta': 'Lire le guide débutant complet',

  'safety.title': 'La sécurité d\u2019abord',
  'safety.body': 'Un lien de spreadsheet n\u2019est pas une garantie de qualité du produit, de fiabilité du vendeur, de sécurité de paiement ni de livraison. Vérifiez toujours les informations avant de commander.',
  'safety.cta': 'Lire le guide de sécurité USFans',

  'teaser.title': 'Derniers guides USFans',
  'teaser.subtitle': 'Des guides frais et originaux écrits pour vous aider à acheter plus intelligemment.',
  'teaser.category': 'Guide',
  'teaser.cardTitle': 'USFans Spreadsheet : guide complet des trouvailles, QC et achats',
  'teaser.cardDesc': 'Découvrez ce qu\u2019est le USFans Spreadsheet, comment l\u2019utiliser, comment vérifier le QC, comprendre la livraison et rester en sécurité avant de commander.',
  'teaser.date': 'Mis à jour août 2026',

  'faq.title': 'Questions fréquentes',
  'faq.q1': 'Qu\u2019est-ce que le USFans Spreadsheet ?',
  'faq.a1': 'Le USFans Spreadsheet est une ressource structurée qui organise les liens de produits, les catégories et les informations d\u2019achat au même endroit. Il aide les acheteurs à découvrir des produits plus rapidement au lieu de chercher dans des publications éparpillées.',
  'faq.q2': 'Comment fonctionne le USFans Spreadsheet ?',
  'faq.a2': 'Il regroupe les produits par catégories et fournit des liens, des guides et des listes de vérification. Vous parcourez une catégorie, consultez les informations produit et les détails QC, puis continuez vers le site principal pour passer commande.',
  'faq.q3': 'USFans est-il légitime ?',
  'faq.a3': 'De nombreux acheteurs utilisent USFans comme point de départ pour trouver des produits, mais un lien seul ne garantit ni la qualité ni la fiabilité. Vérifiez toujours les détails du vendeur, les avis et la sécurité du paiement avant de commander.',
  'faq.q4': 'Combien coûte la livraison USFans ?',
  'faq.a4': 'Le coût de livraison dépend du poids du colis, de la destination et de la route choisie. Les colis plus lourds et les routes plus rapides coûtent plus cher. Vérifiez les tarifs actuels sur le site principal avant de commander.',
  'faq.q5': 'USFans propose-t-il des coupons ?',
  'faq.a5': 'Des promotions et codes de réduction peuvent apparaître de temps en temps. Consultez le site principal et les canaux officiels pour les dernières offres, et vérifiez toujours les conditions et dates d\u2019expiration.',
  'faq.q6': 'Qu\u2019est-ce que l\u2019entrepôt USFans ?',
  'faq.a6': 'L\u2019entrepôt est l\u2019endroit où les produits sont stockés, inspectés et préparés pour l\u2019expédition. Comprendre ce processus vous aide à savoir ce qui arrive à votre commande avant son envoi.',
  'faq.q7': 'Comment vérifier le QC ?',
  'faq.a7': 'Le QC (contrôle qualité) consiste à vérifier les photos, les mesures et l\u2019état du produit avant l\u2019expédition. Comparez les photos QC avec l\u2019annonce et posez des questions si quelque chose n\u2019est pas clair.',
  'faq.q8': 'Ce site est-il officiellement affilié à USFans ?',
  'faq.a8': 'Non. C\u2019est une ressource informative indépendante qui n\u2019est pas affiliée, soutenue ni sponsorisée par USFans. Nous proposons des guides utiles, mais nous ne vendons pas de produits et ne gérons pas de commandes.',

  'finalCta.title': 'Prêt à explorer ?',
  'finalCta.subtitle': 'Commencez par le USFans Spreadsheet, puis utilisez nos guides pour prendre de meilleures décisions.',
  'finalCta.button': 'Explorer USFans Spreadsheet',

  'pillars.title': 'Guides principaux USFans',
  'pillars.subtitle': 'Des guides détaillés sur les sujets les plus importants avant d\u2019acheter.',
  'pillars.readMore': 'Lire la suite',
  'pillars.p1.title': 'Guide complet USFans Spreadsheet',
  'pillars.p1.desc': 'Tout ce qu\u2019il faut savoir pour trouver des produits, vérifier le QC et utiliser le spreadsheet.',
  'pillars.p2.title': 'Avis USFans',
  'pillars.p2.desc': 'Ce que les acheteurs devraient considérer avant d\u2019utiliser la plateforme.',
  'pillars.p3.title': 'Coût de livraison USFans',
  'pillars.p3.desc': 'Comment le poids, la destination et la route influencent les coûts de livraison internationale.',
  'pillars.p4.title': 'Coupons USFans',
  'pillars.p4.desc': 'Comment fonctionnent les coupons, promotions et codes de réduction.',
  'pillars.p5.title': 'Codes de réduction USFans',
  'pillars.p5.desc': 'Où trouver et comment utiliser les codes de réduction en toute sécurité.',
  'pillars.p6.title': 'Entrepôt USFans',
  'pillars.p6.desc': 'Comment fonctionnent le stockage, l\u2019inspection et la préparation des colis.',
  'pillars.p7.title': 'USFans est-il légitime ?',
  'pillars.p7.desc': 'Un regard pratique sur la sécurité et la légitimité avant de commander.',
  'pillars.p8.title': 'Guide de sécurité USFans',
  'pillars.p8.desc': 'Comment éviter les risques et acheter en toute confiance.',
  'pillars.p9.title': 'Guide QC USFans',
  'pillars.p9.desc': 'Comment lire les photos QC et vérifier les mesures.',
  'pillars.p10.title': 'Guide d\u2019achat USFans',
  'pillars.p10.desc': 'Un parcours étape par étape de la recherche à la commande.',
};